import React from 'react';

export function useQuery (search) {
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }